<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('catalogue.newProduct.facesAssociees') }}
      </p>
    </header>
    <div class="mg-4" v-if="$route.name === 'm.bodac.catalogue-editionReseau'">
      <app-information-msg-component :title="$t('detailProduitReseau.infoFacesAssociesReseau')"
                                    :libelleList="getMessagesInfo">
      </app-information-msg-component>
    </div>
    <div class="card-content">
      <div class="level columns">
        <div class="level-left column is-6">
          <div class="columns" v-if="facesList.length">
            <form @submit.prevent.stop="filter = filterInput; updateDateVisualisation();"
              class="column is-8">
              <b-input :placeholder="$t('catalogue.actions.searchFace')"
                       v-model="filterInput" type="search">
              </b-input>
            </form>
            <div class="column is-4">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            icon="calendar-today"
                            @input="updateDateVisualisation"
                            v-model="dateVisualisation"
                            :editable="true">
              </b-datepicker>
            </div>
          </div>
        </div>
        <div class="level-right column is-6">
          <div class="columns is-pulled-right">
            <div class="column is-narrow">
              <form @submit.prevent.stop="ajouterFace">
                <div class="is-pulled-right field">
                  <div class="control inputSearch is-clearfix">
                    <b-autocomplete
                      class="dropdown is-bottom-left is-block"
                      v-model="critereRecherche"
                      :open-on-focus="false"
                      :data="autocompleteFacesList"
                      field="label"
                      :loading="isFetching"
                      @select="face => selectFace(face)"
                      @input="getAsyncFaceData"
                      @keyup.native.enter="onPressEnter"
                      :placeholder="$t('catalogue.actions.ajouterFace')">
                      <template slot="empty">
                        <div v-if="!isFetching">
                          {{$t('general.autocomplete.noRslt')}}
                        </div>
                        <div v-else>
                          {{$t('general.autocomplete.search')}}
                        </div>
                      </template>
                    </b-autocomplete>
                  </div>
                </div>
              </form>
            </div>
            <div class="column is-narrow">
              <button class="button is-primary"
                      @click="goToEcranAddFaces()"
                      type="submit">
                {{ $t('catalogue.actions.ajoutFaceViaEcran') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <template v-if="facesList.length">
        <div class="level">
          <div class="level-left">
            <selecteur-action
              @handleAction="handleAction"
              :elementsSelectionnes="isFaceSelected"
              :titleButton="'general.button.apply'"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
            ></selecteur-action>
          </div>
          <div class="level-right">
            <exportExcelButton
              :perm="permCatalogue.exporter"
              :action="exporter"/>
          </div>
        </div>
        <v-client-table :data="filteredFacesList"
                        class='mgt-10px column is-12 is-paddingless'
                        :columns="columns"
                        :options="options"
                        ref='tableRemises'>
          <template slot='afterTable'>
            <table-items-in-view @input="$refs.tableRemises.setLimit($event)"/>
          </template>
          <div slot="produit.reference" slot-scope="props" class="link">
            <router-link-blank
              :to="{ name: 'c.bodac.catalogue-face', params: { id: props.row.produit.id }}"
              class="lien"
              :message="props.row.produit.reference">
            </router-link-blank>
          </div>
          <div slot="formatAffiche" slot-scope="props" class="link">
            <router-link-blank v-if="getFormatAffiche(props.row.produit.produitFace)"
              :to="{
                name: 'c.bodac.format_affiche',
                params: { id: getFormatAffiche(props.row.produit.produitFace).id }}"
              class="lien"
              :message="getFormatAffiche(props.row.produit.produitFace).code">
            </router-link-blank>
          </div>
          <div slot="selected" slot-scope="props" class="has-text-centered">
            <qd-checkbox v-model="facesList[indexOfFace(props.row)].selected">
            </qd-checkbox>
          </div>
          <div slot="reseauFaceTags" slot-scope="props">
            <query-tags-tag-input :key="props.row.guid"
              :tooltipLabel="$t('editionCampagne.tagInfo')"
              v-model="facesList[indexOfFace(props.row)].reseauFaceTags"
              field="tag"
              :moduleTag="constantes.moduleTagSousReseau">
            </query-tags-tag-input>
          </div>
          <div slot="startDate" slot-scope="props">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          :class="{'is-danger':
                           startDateHasError(facesList[indexOfFace(props.row)])}"
                          v-model="facesList[indexOfFace(props.row)].dateDebut"
                          position="is-bottom-left"
                          :editable="true">
            </b-datepicker>
          </div>
          <div slot="endDate" slot-scope="props">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          :class="{'is-danger': dateHasError(facesList[indexOfFace(props.row)])}"
                          v-model="facesList[indexOfFace(props.row)].dateFin"
                          :min-date="facesList[indexOfFace(props.row)].dateDebut"
                          position="is-bottom-left"
                          :editable="true">
            </b-datepicker>
          </div>
          <div slot="listeAffichage" slot-scope="props">
            {{ props.row.listeAffichage }}
          </div>
          <div slot="supprimer" slot-scope="props" class="has-text-centered">
            <a @click="setFaceToDelete(props.row)">
              <b-icon
                icon="delete-forever"
                type="is-danger">
              </b-icon>
            </a>
          </div>
        </v-client-table>
      </template>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="faceToDelete || getNumberFaceSelected === 1
        ? this.$t('catalogue.popUpSuppressionFace.message')
        : this.$t('catalogue.popUpSuppressionFace.messageMulti')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="faceToDelete ? supprimerFace() : supprimerMultipleFace()"/>
    </b-modal>
    <b-modal v-model="popUpModificationDate" has-modal-card class="modal">
      <pop-up-modification-date-face
        :messHeader="messHeader"
        :dateTitle="dateTitle"
        @close="popUpModificationDate = false"
        @yes="modifierDateFace"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { INFINITE_DAY } from '@/configuration/general';
import genererGuid from '@/services/general/genererGuid';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import { getAll } from '@/api/produit/produitFace';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import exportListeFacesToExcel from '@/services/excel/exportFace/exportListeFacesToExcel';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import formatDate from '@/services/general/formatDate';
import { SET_PRODUIT } from '@/store/modules/produit-mutation-type';
import { SET_BRIEF } from '@/store/modules/produitFace-mutation-type';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import getAgenceId from '@/services/general/getSocieteId';
import {
  CATEGORIE_REGROUPEMENT_MAIRIE,
  ACTION_MODIFIER_DATE_DEBUT,
  ACTION_MODIFIER_DATE_FIN,
} from '@/configuration/catalogue/produitConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import PopUpModificationDateFace from '@/components/catalogue/produitReseau/popUpModificationDateFace';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { SOUS_RESEAU as moduleTagSousReseau } from '@/configuration/parametrage/tagConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { columnsSplice } from '@/services/general/columns';

const ProduitStore = createNamespacedHelpers('produit');
const ProduitFace = createNamespacedHelpers('produitFace');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    breadcrumb: {
      type: Array,
      required: true,
    },
    dateVisualisation: {
      type: Date,
      required: false,
    },
  },
  data: () => ({
    critereRecherche: '',
    facesList: [],
    autocompleteFacesList: [],
    selectedFace: null,
    isFetching: false,
    filter: '',
    filterInput: '',
    permCatalogue: CATALOGUE,
    filteredFacesList: [],
    actions: [
      { action: ACTION_DELETE, translation: 'catalogue.actions.delete' },
      { action: ACTION_MODIFIER_DATE_DEBUT, translation: 'catalogue.actions.modifierDateDebut' },
      { action: ACTION_MODIFIER_DATE_FIN, translation: 'catalogue.actions.modifierDateFin' },
    ],
    popUpSuppression: false,
    faceToDelete: null,
    dateTitle: '',
    popUpModificationDate: false,
    messHeader: '',
    actionModifSelected: null,
    constantes: {
      moduleTagSousReseau,
    },
  }),
  components: {
    queryTagsTagInput,
    routerLinkBlank,
    TableItemsInView,
    selecteurAction,
    popUpPrevention,
    AppInformationMsgComponent,
    PopUpModificationDateFace,
    exportExcelButton,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    moduleLogistiqueImpression() {
      const { moduleLogistiqueImpression } = typesParametres.PARAMETRES_INTERNE_KEYS;
      return this.parametresInterne(moduleLogistiqueImpression.key);
    },
    columns() {
      const columns = [
        'selected',
        'produit.reference',
        'formatAffiche',
        'produit.produitFace.format',
        'produit.produitFace.materielType',
        'adresse',
        'produit.produitFace.adresse.codePostal',
        'produit.produitFace.adresse.ville',
        'reseauFaceTags',
        'startDate',
        'endDate',
        'listeAffichage',
        'supprimer'];
      if (!this.moduleLogistiqueImpression) {
        columnsSplice(columns, 'formatAffiche');
      }
      return columns;
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    iconSelectTotal() {
      if (this.areAllSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          'produit.reference': this.$i18n.t('catalogue.table.face'),
          formatAffiche: this.$i18n.t('catalogue.table.formatAffiche'),
          'produit.produitFace.format': this.$i18n.t('catalogue.table.format'),
          'produit.produitFace.materielType': this.$i18n.t('catalogue.table.materiel'),
          adresse: this.$i18n.t('catalogue.table.adresse'),
          'produit.produitFace.adresse.codePostal': this.$i18n.t('catalogue.table.codePostal'),
          'produit.produitFace.adresse.ville': this.$i18n.t('catalogue.table.ville'),
          reseauFaceTags: this.$i18n.t('catalogue.table.reseauFaceTags'),
          startDate: this.$i18n.t('catalogue.table.startDate'),
          endDate: this.$i18n.t('catalogue.table.endDate'),
          listeAffichage: this.$i18n.t('catalogue.table.listeAffichage'),
          supprimer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.areAllSelected;
                    this.filteredFacesList.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
          adresse: 'ellipsis address',
          startDate: 'date',
          endDate: 'date',
          reseauFaceTags: 'width-300px',
        },
        customSorting: {
          adresse(ascending) {
            const sortMethod = (a, b) => {
              const addressA = Number(a.adresse.split(',')[0]);
              const addressB = Number(b.adresse.split(',')[0]);
              if (ascending) {
                return addressA <= addressB ? -1 : 1;
              }
              return addressA >= addressB ? -1 : 1;
            };
            return sortMethod;
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortIcon: SORT_ICON,
        sortable: [
          'produit.reference',
          'produit.produitFace.format',
          'produit.produitFace.materielType',
          'adresse',
          'produit.produitFace.adresse.codePostal',
          'produit.produitFace.adresse.ville',
        ],
      };
    },
    isFaceSelected() {
      return this.facesList.some(item => item.selected);
    },
    areAllSelected() {
      return this.filteredFacesList.length && !this.filteredFacesList.some(item => !item.selected);
    },
    getNumberFaceSelected() {
      return this.filteredFacesList.filter((face) => { return face.selected; }).length;
    },
    getMessagesInfo() {
      return [{
        isLink: false,
        libelle: this.$i18n.t('detailProduitReseau.facesAssociesReseauMessage'),
      }];
    },
  },
  async created() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.formatAffiche]);
      this.facesList = this.produit.produitReseau.affectationsReseauFace;
      this.facesList.forEach(item => {
        item.guid = genererGuid();
        this.$set(item, 'selected', false);
        this.$set(item, 'isAlreadySelect', true);
        if (!item.reseauFaceTags) {
          this.$set(item, 'reseauFaceTags', []);
        }
        if (item.dateDebut) {
          item.dateDebut = new Date(item.dateDebut);
        }
        if (item.dateFin) {
          item.dateFin = new Date(item.dateFin);
        }
        this.$set(item, 'adresse', this.getAddressLabel(item.produit.produitFace));
      });
      this.initfilteredFacesList();
      this.loadTourneeLigne();
    } catch (err) {
      messageErreur(this.$i18n);
      throw err;
    } finally {
      loadingComponent.close();
    }
  },
  methods: {
    ...ProduitStore.mapMutations({
      setProduit: SET_PRODUIT,
    }),
    ...ProduitFace.mapMutations({
      setCriteresRecherche: SET_BRIEF,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    async goToEcranAddFaces() {
      this.setProduit(this.produit);
      this.setCriteresRecherche({ fromDate: this.dateVisualisation });
      await this.$router.push({
        name: 'l.bodac.catalogue-ajoutFacesAuReseau',
        params: { breadcrumb: this.breadcrumb },
      });
    },
    updateDateVisualisation(newValue) {
      this.$emit('editDateVisualisation', newValue);
      this.initfilteredFacesList();
    },
    onUpdateAffectations() {
      this.facesList = this.produit.produitReseau.affectationsReseauFace;
      this.initfilteredFacesList();
    },
    initfilteredFacesList() {
      this.facesList.forEach((face) => {
        face.selected = false;
      });
      this.filteredFacesList = this.facesList.filter(item => {
        const fields = [
          item.produit.reference,
          item.produit.produitFace.format,
          item.produit.produitFace.materielType,
          item.produit.produitFace.adresse.adresse1,
          item.produit.produitFace.adresse.adresse2,
          item.produit.produitFace.adresse.adresse3,
          item.produit.produitFace.adresse.codePostal,
          item.produit.produitFace.adresse.ville,
        ];
        let find = false;
        const dateFin = item.dateFin ? moment(item.dateFin) : moment(INFINITE_DAY);
        if (!this.dateVisualisation
          || moment(this.dateVisualisation).isBetween(moment(item.dateDebut),
            dateFin, 'day', '[]')) {
          fields.forEach((field) => {
            if (field && field.toLowerCase().includes(this.filter.toLowerCase())) {
              find = true;
            }
          });
        }
        return find;
      });
    },
    setTags(row, value) {
      this.facesList[this.indexOfFace(row)].reseauFaceTags = value;
    },
    getTagsLibelles(tags) {
      if (!tags.length) return [];
      return tags
        .map(t => t?.tag?.libelle || (typeof t.tag === 'string' ? t.tag : ''))
        .filter(Boolean)
        .join(', ');
    },
    exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const faces = this.facesList.filter((face) => {
          const dateFin = face.dateFin ? moment(face.dateFin) : moment(INFINITE_DAY);
          return moment(this.dateVisualisation).isBetween(moment(face.dateDebut), dateFin, 'day', '[]');
        });
        faces.forEach(face => {
          face.sousReseauExport = this.getTagsLibelles(face.reseauFaceTags);
        });
        exportListeFacesToExcel(faces, this.$i18n);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelFace.messages.excelExportError'));
        loadingComponent.close();
        throw e;
      }
    },
    async getAsyncFaceData() {
      if (this.critereRecherche && this.critereRecherche.length < 3) {
        this.autocompleteFacesList = [];
        return;
      }
      this.isFetching = true;
      this.autocompleteFacesList = [];
      const agencesId = await getAgenceId();
      const result = {
        query: {
          societeId: this.produit.supportCommercial.societeId,
          references: [this.critereRecherche],
          proposableReseau: (this.produit.supportCommercial.categorieVente
            !== CATEGORIE_REGROUPEMENT_MAIRIE ? true : null),
          nonCommercialisable: (this.produit.supportCommercial.categorieVente
            === CATEGORIE_REGROUPEMENT_MAIRIE),
          agencesId,
        },
      };
      const response = await getAll(result);
      this.isFetching = false;
      this.autocompleteFacesList = response.data.result.items;

      this.autocompleteFacesList.forEach(item => {
        const face = item.produitFace;
        item.label = item.reference + ' - ' + face.codePanneau + ' - ';
        item.label += face.adresse.adresse1 ? face.adresse.adresse1 : '';
        item.label += face.adresse.codePostal && face.adresse.adresse1 ? ' ' : '';
        item.label += face.adresse.codePostal ? face.adresse.codePostal : '';
        item.label += face.adresse.adresse1 || face.adresse.codePostal ? ' - ' : '';
        item.label += face.adresse.ville;
        this.$set(item, 'selected', false);
      });
    },
    selectFace(face) {
      if (face) {
        this.selectedFace = face;
        this.ajouterFace();
        this.onUpdateAffectations();
      }
    },
    ajouterFace() {
      if (this.selectedFace) {
        const item = {};
        item.produit = this.selectedFace;
        item.selected = false;
        item.dateDebut = new Date();
        item.dateFin = null;
        item.guid = genererGuid();
        item.adresse = this.getAddressLabel(item.produit.produitFace);
        this.produit.produitReseau.affectationsReseauFace.unshift(item);
        this.critereRecherche = null;
        this.selectedFace = null;
      }
    },
    setFaceToDelete(face) {
      this.faceToDelete = face;
      this.popUpSuppression = true;
    },
    supprimerFace() {
      const index = this.produit.produitReseau.affectationsReseauFace.findIndex((affectation) => {
        return affectation.produit.id === this.faceToDelete.produit.id
          && formatDate(affectation.dateDebut) === formatDate(this.faceToDelete.dateDebut)
          && formatDate(affectation.dateFin) === formatDate(this.faceToDelete.dateFin);
      });
      if (index > -1) {
        this.produit.produitReseau.affectationsReseauFace.splice(index, 1);
        this.onUpdateAffectations();
      }
      messageSucces(this.$t('catalogue.popUpSuppressionFace.success'));
      this.popUpSuppression = false;
      this.faceToDelete = null;
    },
    supprimerMultipleFace() {
      const facesSelected = this.filteredFacesList.filter((face) => { return face.selected; });
      facesSelected.forEach(item => {
        const index = this.produit.produitReseau.affectationsReseauFace.findIndex((affectation) => {
          return affectation.produit.id === item.produit.id
            && formatDate(affectation.dateDebut) === formatDate(item.dateDebut)
            && formatDate(affectation.dateFin) === formatDate(item.dateFin);
        });
        if (index > -1) {
          this.produit.produitReseau.affectationsReseauFace.splice(index, 1);
          this.onUpdateAffectations();
        }
      });
      this.popUpSuppression = false;
      messageSucces(this.$t('catalogue.popUpSuppressionFace.successMulti'));
    },
    getAddressLabel(face) {
      let address = '';
      address = face.adresse.adresse1;
      if (face.adresse.adresse2) {
        address += `, ${face.adresse.adresse2}`;
      }
      if (face.adresse.adresse3) {
        address += `, ${face.adresse.adresse3}`;
      }
      return address;
    },
    indexOfFace(face) {
      const item = this.facesList.find(item => item.guid === face.guid);
      return this.facesList.indexOf(item);
    },
    dateHasError(face) {
      return this.$parent.error && moment(face.dateDebut).isAfter(moment(face.dateFin));
    },
    startDateHasError(item) {
      return !item.dateDebut && this.$parent.error;
    },
    onPressEnter() {
      if (this.selectedFace) {
        this.ajouterFace();
      }
    },
    handleAction(action) {
      switch (action) {
        case ACTION_DELETE:
          this.faceToDelete = null;
          this.popUpSuppression = true;
          break;
        case ACTION_MODIFIER_DATE_DEBUT:
          this.dateTitle = this.$i18n.t('catalogue.table.startDate');
          this.messHeader = this.getNumberFaceSelected === 1 ? this.$t('catalogue.popUpModicationDateFace.messageDateDebut')
            : this.$t('catalogue.popUpModicationDateFace.messageDateDebutMulti');
          this.popUpModificationDate = true;
          this.actionModifSelected = ACTION_MODIFIER_DATE_DEBUT;
          break;
        case ACTION_MODIFIER_DATE_FIN:
          this.dateTitle = this.$i18n.t('catalogue.table.endDate');
          this.messHeader = this.getNumberFaceSelected === 1 ? this.$t('catalogue.popUpModicationDateFace.messageDateFin')
            : this.$t('catalogue.popUpModicationDateFace.messageDateFinMulti');
          this.actionModifSelected = ACTION_MODIFIER_DATE_FIN;
          this.popUpModificationDate = true;

          break;
        default:
          break;
      }
    },
    modifierDateFace(dateModifiee) {
      this.filteredFacesList.filter((face) => { return face.selected; })
        .forEach(face => {
          if (this.actionModifSelected
              && this.actionModifSelected === ACTION_MODIFIER_DATE_DEBUT) {
            face.dateDebut = dateModifiee;
          } else if (this.actionModifSelected
              && this.actionModifSelected === ACTION_MODIFIER_DATE_FIN) {
            face.dateFin = dateModifiee;
          }
          this.onUpdateAffectations();
        });
      this.actionModifSelected = null;
      this.popUpModificationDate = false;
      this.dateTitle = '';
      this.messHeader = '';
    },
    async loadTourneeLigne() {
      const tourneeLigneWithFaceId = (
        await getAllTourneeLigne({
          query: {
            faceIds: this.filteredFacesList
              .filter(f => !!f.produit?.produitFace?.faceId)
              .map(f => f.produit.produitFace.faceId),
            societeId: this.societeActiveId,
          },
          limit: NO_PAGINATION,
        })
      ).data.result.items;
      this.filteredFacesList.forEach(item => {
        this.$set(item, 'listeAffichage', tourneeLigneWithFaceId.find(t => t.faceId
          === item.produit?.produitFace?.faceId)?.tournee?.libelle || null);
      });
    },
    getFormatAffiche(produit) {
      const formatAfficheId = produit.face?.materiel?.materielTechnique?.formatAfficheId;
      if (!formatAfficheId) {
        return null;
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.formatAffiche)
        .find((f) => {
          return f.id === formatAfficheId;
        });
    },
  },
};

</script>
